import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Grid, useMediaQuery } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import SendIcon from '@mui/icons-material/Send';
import LoginIcon from '@mui/icons-material/Login';
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Header from '../signup/Header';
import FontSize from '../../layouts/FontSize';
import Color from '../../layouts/Color';
import { useTheme } from '@emotion/react';
import { graphUserForgotPass } from '../../services/Authenticate';

const phoneRegExp = /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/
const validationSchema = Yup.object({
    phone: Yup.string()
        .required("Phone is required")
        .matches(phoneRegExp, 'Error phone format'),
    email: Yup
        .string('Enter your email')
        .email('Error Email Format')
        .required('Email is required'),
});
const circleCheck = { fontSize: FontSize.Huge, color: Color.Main, mb: 2 };
const sendLink = {
    mt: 3, mb: 3,
    bgcolor: Color.Main,
    borderRadius: '30px',
    boder: '1px solid',
    fontWeight: '500',
    textAlign: 'center',
    padding: '10px 30px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    width: '240px',
    '&:hover': { background: Color.Button, color: Color.Normal }
};

const loginButton = {
    mt: 3, mb: 3,
    bgcolor: Color.Main,
    borderRadius: '30px',
    boder: '1px solid',
    fontWeight: '500',
    textAlign: 'center',
    padding: '10px 30px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    width: '240px',
    '&:hover': { background: Color.Button, color: Color.Normal }
}

export default function MainForgotPassword() {
    const theme = useTheme();
    const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
    const [isSuccess, setIsSuccess] = useState(false);
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            phone: '',
            email: '',
        },
        validationSchema: validationSchema,
        onSubmit: (e) => { handleSubmit(e) }
    });
    const handleSubmit = (e) => {
        dispatch(openLoadingApi());
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: '',
        };

        graphUserForgotPass(e.email, e.phone)
            .then(result => {
                setIsSuccess(true)
                alert = { ...alert, message: " The link to change password has been sent to your email successfully!", severity: 'success', title: 'Success' };
                dispatch(closeLoadingApi());
                dispatch(showAlert(alert));
            }).catch(error => {
                const err = JSON.parse(JSON.stringify(error));
                alert = { ...alert, message: err.response.errors[0].message };
                dispatch(showAlert(alert));
                dispatch(closeLoadingApi());
            })
    }
    const handleChangeSignin = () => {
        setIsSuccess(false)
    }
    return (
        <div>
            <Header></Header>
            <section className="sign-in-up login">
                <div className="overlay  pb-120" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="form-content">
                                    {isSuccess === false ?
                                        <div className="section-header">
                                            <h2 className="title">Forgot Password</h2>
                                            <h5 className="sub-title">Enter your Phone number and Email</h5>
                                        </div>
                                        :
                                        <div>
                                            <div className="section-header">
                                                <CheckCircleOutlineIcon sx={circleCheck} />
                                                <h2 className="title">Forgot Password</h2>
                                                <h5 className="sub-title">If provided email is a registered email ID on Apollo, you will receive an email with further instructions on how to reset your password.</h5>
                                            </div>
                                        </div>
                                    }
                                    <form onSubmit={formik.handleSubmit} noValidate>
                                        {isSuccess === false ?
                                            <Grid container spacing={2} justifyContent="center">
                                                <Grid item xs={8}>
                                                    <TextField
                                                        fullWidth
                                                        margin="dense"
                                                        id="phone"
                                                        label="Phone Number"
                                                        name="phone"
                                                        value={formik.values.phone}
                                                        onChange={formik.handleChange}
                                                        error={Boolean(formik.errors.phone)}
                                                        helperText={formik.errors.phone}
                                                        autoComplete="phone"
                                                        autoFocus
                                                        required
                                                        variant='outlined'
                                                        size={matchDownMD ? 'small' : "medium"}
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                bgcolor: theme.palette.background.default
                                                            },
                                                            '& .MuiOutlinedInput-root': {
                                                                bgcolor: theme.palette.background.default
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <TextField
                                                        fullWidth
                                                        margin="dense"
                                                        value={formik.values.email}
                                                        onChange={formik.handleChange}
                                                        error={Boolean(formik.errors.email)}
                                                        helperText={formik.errors.email}
                                                        required
                                                        id="email"
                                                        label="Email"
                                                        name="email"
                                                        autoComplete="email"
                                                        autoFocus
                                                        variant='outlined'
                                                    />
                                                </Grid>
                                            </Grid>
                                            : <Grid></Grid>}
                                        {isSuccess === false ?
                                            (<Grid item xs={12}>
                                                <div className="btn-area">
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        sx={sendLink}
                                                        endIcon={<SendIcon></SendIcon>}
                                                    >
                                                        Send Link
                                                    </Button>
                                                </div>
                                            </Grid>)
                                            :
                                            (<Grid item xs={12}>
                                                <div className="btn-area">
                                                    <Button
                                                        variant="contained"
                                                        href="/signin"
                                                        onChange={handleChangeSignin}
                                                        sx={loginButton}
                                                        endIcon={<LoginIcon></LoginIcon>}
                                                    >
                                                        Sign In
                                                    </Button>
                                                </div>
                                            </Grid>)}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}